import api from './api';
import { ISession, ILogin } from '../common/interfaces/signIn.interfaces';

export function signIn(login: ILogin): Promise<ISession> {
    return api.post('/login', login).then(res => res.data);
}